import React from "react";
import BackArrow from "./back.svg";
import classes from "./privacy.module.scss";
import cn from "classnames";

//components start
import Button from "components/UI/button";
import Footer from "components/UI/footer";
import Header from "components/UI/header";
//components endUI

import { isNil } from "lodash";
import FormattedHTMLMessage from "components/UI/FormattedHTMLMessage";

const PrivacyPolicy = ({
  isPrivacyPolicyOpen,
  setPrivacyPolicyOpen,
  setPrivacyPolicyAgreed,
  setFieldValue,
  no_header,
}) => {
  return (
    <>
      <div
        className={cn(classes.container, isPrivacyPolicyOpen && classes.open)}
      >
        {isNil(no_header) && <Header transparent />}
        <div className={classes.policyWrapper}>
          <div
            className={classes.backArrowWrapper}
            onClick={() => {
              setPrivacyPolicyOpen(false);
            }}
          >
            <img
              alt={"Back Arrow"}
              className={classes.backArrow}
              src={BackArrow}
            />
          </div>
          <FormattedHTMLMessage
            id={"privacy.policy"}
            value={
              "<h1>What is Lorem Ipsum</h1> <p> Cras rutrum consequat enim, quis scelerisque elit maximus ac. Praesent posuere nisl dolor, et semper nunc venenatis a. Ut id felis nec neque imperdiet rhoncus venenatis id turpis. Nunc semper elit sit amet massa accumsan, non tristique diam ornare. Vivamus at condimentum odio. Phasellus venenatis massa nec urna posuere, et laoreet lectus laoreet. Nam gravida sem sit amet sodales feugiat. In hac habitasse platea dictumst. Fusce sit amet tincidunt odio, </p> <h1>What is Lorem Ipsum</h1> <p> Cus. Sed non arcu feugiat, bibendum diam at, efficitur est. Donec eleifend nisl vel dictum ultrices. Praesent pharetra erat nec massa mattis, porttitor efficitur est pulvina </p> <ul> <li>What is Lorem Ipsum;</li> <li> Fusce sit amet tincidunt odio, ut porttitor dui. Duis tincidunt leo in pretium malesuada </li> <li> Fusce fringilla risus ligula, a aliquet tortor elementum quis. In auctor vel magna vel sagittis. Cras nunc dolor, cursus in augue a, viverra viverra just </li> <li> Sed mattis porttitor hendrerit. Etiam rhoncus malesuada odio et convallis. </li> <li> Sed mattis porttitor hendrerit. Etiam rhoncus malesuada odio et convallis. </li> </ul> <h1> Sed mattis porttitor hendrerit. Etiam rhoncus malesuada odio et convallis. </h1> <p> Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it ove </p> <ul> <li> Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it ove </li> <li> Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it ove </li> <li> Sed mattis porttitor hendrerit. Etiam rhoncus malesuada odio et convallis. </li> <li> Morbi orci ligula, tempus in dapibus ac, pellentesque sed nisl. Duis placerat, nibh eu tincidunt luctus, nulla elit iaculis arcu, nec consectetur turpis mauris ut quam. </li> </ul> <h1>Neque porro quisquam est qui dolorem</h1> <p> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec nec est </p> <ul> <li>Neque porro quisquam est qui dolorem</li> <li> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec nec est </li> </ul> <p>Neque porro quisquam est qui dolorem</p> <ul> <li> Etiam rhoncus malesuada odio et convallis. Donec mi tortor, feugiat vitae dictum nec, eleifend sed libero. Proin volutpat mi eget lorem aliquam, </li> <li> Etiam rhoncus malesuada odio et convallis. Donec mi tortor, feugiat vitae dictum nec, eleifend sed libero. Proin volutpat mi eget lorem aliquam, </li> </ul> <h1>Neque porro quisquam est qui dolorem</h1> <p> Cras in nisl ut augue placerat eleifend. Vivamus blandit semper luctus. Fusce porttitor quam sem, a vulputate odio dapibus sit amet. Sed sit amet sollicitudin ante, a hendrerit purus. Sed velit augue, congue ac accumsan nec, molestie non arcu. Fusce dignissim faucibus scelerisque. Aenean dictum vulputate facilisis. Pellen </p> <p> Cras rutrum consequat enim, quis scelerisque elit maximus ac. Praesent posuere nisl dolor, et semper nunc venenatis a. Ut id felis nec neque imperdiet rhoncus venenatis id turpis. Nunc semper elit sit amet massa accumsan, non tristique diam ornare. Vivamus at condimentum odio. Phasellus venenatis massa nec urna posuere, et laoreet lectus laoreet. Nam gravida sem sit amet sodales feugiat. In hac habitasse platea dictumst. Fusce sit amet tincidunt odio, ut porttitor dui. Duis tincidunt leo in pretium malesuada. Fusce fringilla risus ligula, a aliquet tortor elementum qui </p> <p> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis venenatis arcu vitae vulputate scelerisque. Donec malesuada facilisis tortor, ac accumsan diam tempor at. Proin </p> <p> Cras in nisl ut augue placerat eleifend. Vivamus blandit semper luctus. Fusce porttitor quam sem, a vulputate odio dapibus sit amet. Sed sit amet sollicitudin ante, a hendrerit purus. Sed velit augue, congue ac accumsan nec, molestie non arcu. Fusce dignissim faucibus scelerisque. Aenean dictum vulputate facilisis. Pellen </p>"
            }
          />

          <FormattedHTMLMessage
            id={"privacy.policy.1"}
            value={
              " "
            }
          />

          <FormattedHTMLMessage
            id={"privacy.policy.2"}
            value={
              " "
            }
          />    


        </div>
        <Footer>
          <Button
            formatID="privacy.button"
            id="apply-button"
            text="I agree"
            onClick={() => {
              setPrivacyPolicyOpen(false);
              setPrivacyPolicyAgreed(true);
              setFieldValue("checkbox", true);
            }}
          />
        </Footer>
      </div>
    </>
  );
};

export default PrivacyPolicy;
